<!-- 钓鱼小游戏面板：抛竿→咬钩→搏斗（收线/拉扯/中鱼区/张力）→中鱼/跑鱼 -->
<template>
    <div id="fishingDiv" class="wrap">
        <el-dialog :visible.sync="fishingVisible"
        :before-close="fishing_dialog_close" v-loading="loading" append-to-body
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading"
         title="钓鱼" :close-on-click-modal="phase != 'battling'">
            <div class="fish-scene">
                <!-- 水面与波纹 -->
                <div class="water">
                    <div class="wave wave1"></div>
                    <div class="wave wave2"></div>
                    <div class="wave wave3"></div>
                </div>
                <!-- 浮漂（等待咬钩时抖动） -->
                <div v-if="phase === 'waiting'" class="bobber" :class="{nibble: waitingHint}">
                    <div class="bobber-dot"></div>
                </div>
                <!-- 鱼（搏斗时挣扎） -->
                <div v-if="phase === 'battling'" class="fish-icon"
                     :class="{struggling: tension > 50}">
                    🐟
                </div>
                <!-- 渔获水面展示：中鱼后鱼跃出水面的庆祝动画（固定左右居中） -->
                <div v-if="showcase" class="showcase-float">
                    <div class="showcase-splash" :class="{'splash-rare': showcase.rareLevel >= 2}"></div>
                    <img v-if="showcase.fishImgsrc" :src="ossPath + showcase.fishImgsrc"
                         class="showcase-fish" :class="{'showcase-fish-rare': showcase.rareLevel >= 2}"
                         alt="渔获">
                    <span v-else class="showcase-emoji" :class="{'showcase-fish-rare': showcase.rareLevel >= 2}">🐟</span>
                    <div class="showcase-name" :style="{color: showcase.rareColor}">
                        {{showcase.fishTypeName}}
                        <span v-if="showcase.rareLevel >= 1" class="showcase-tag" :style="{color: showcase.rareColor, borderColor: showcase.rareColor}">{{showcase.rareLabel}}</span>
                    </div>
                </div>
                <!-- 蓄力力量条：按住抛竿按钮时来回摆动，绿色区间为最佳抛投点（随场景定位，不参与布局不跳动） -->
                <div v-if="phase === 'casting'" class="power-wrap">
                    <div class="power-head">
                        <span class="power-label">🎣 蓄力 {{powerDisplay}}%</span>
                        <span class="power-tip">绿色区间（55%~85%）松手抛得最远最准！</span>
                    </div>
                    <div class="powerbar">
                        <div class="powerbar-best"></div>
                        <div class="powerbar-fill" :class="{'powerbar-perfect': castPerfect}" :style="{width: powerValue + '%'}"></div>
                        <div class="powerbar-marker" :style="{left: powerValue + '%'}"></div>
                    </div>
                </div>
                <!-- 状态文案 -->
                <div class="scene-text">
                    <span v-if="phase === 'idle'">水面波光粼粼，准备好鱼竿和鱼饵了吗？</span>
                    <span v-else-if="phase === 'casting'" :class="{'perfect-text': castPerfect}">{{castPerfect ? '🌟 完美蓄力！快松手抛竿！' : '蓄力中……松手抛竿！'}}</span>
                    <span v-else-if="phase === 'waiting'">{{castPerfect ? '🌟 完美的抛竿！' : ''}}浮漂落在 <b>{{castDistance}}</b> 米外，耐心等待鱼儿咬钩……</span>
                    <span v-else-if="phase === 'battling'" class="battle-text" :class="{'danger': tension > 70, 'hook-hint': buffering}">
                        {{buffering ? '🎣 鱼上钩了！快按住收线！' : (tension > 80 ? '线快断了！！松开收线！' : (inZone ? (zoneMoveRate >= 60 ? '⚠️ 鱼躁动了，绿区随时会漂移！' : '鱼累了！稳住！') : '鱼在挣扎，把它拉进绿色中鱼区！'))}}
                    </span>
                    <span v-else-if="phase === 'result'" :class="result && result.success ? 'success-text' : 'fail-text'">
                      <template v-if="result && result.success && result.fishTypeName">
                        <!-- 渔获浮层已展示「名字+稀有标签」时，状态栏只留文案尾巴，避免同一个名字出现两次 -->
                        <template v-if="showcase">{{result.message ? result.message.slice(result.message.indexOf('】') + 1) : ''}}</template>
                        <template v-else>
                          <span :style="{color: rareColor(result.rareLevel)}">{{result.fishTypeName}}</span>
                          <span v-if="result.rareLevel >= 2" class="rare-tag">{{rareNameMap[result.rareLevel]}}</span>
                          <span v-else>{{result.message ? result.message.slice(result.message.indexOf('】') + 1) : ''}}</span>
                        </template>
                      </template>
                      <template v-else>{{result ? result.message : ''}}</template>
                    </span>
                </div>
            </div>

            <!-- 搏斗区：抛竿后立即显示，等待咬钩时置灰 -->
            <div v-if="phase === 'waiting' || phase === 'battling'" class="battle-ui" :class="{'battle-ui-waiting': phase === 'waiting'}">
                <div class="fishbar-wrap">
                    <div class="fishbar-label">收线进度</div>
                    <div class="fishbar">
                        <div class="fishbar-red-left"></div>
                        <div class="fishbar-zone" :class="{'zone-alert': zoneMoveRate >= 60}" :style="zoneStyle"></div>
                        <div class="fishbar-red-right"></div>
                        <div class="fishbar-marker" :style="{left: progress + '%'}"></div>
                    </div>
                </div>
                <div class="tension-wrap">
                    <div class="tension-label">鱼线张力</div>
                    <div class="tensionbar">
                        <div class="tensionbar-fill" :class="tensionClass" :style="{width: tension + '%'}"></div>
                    </div>
                    <div class="tension-num" :class="tensionClass">{{tension}}%</div>
                </div>
                <div class="battle-actions">
                    <button class="reel-btn" :class="{reeling: holding, 'reel-hint': buffering}"
                        :disabled="phase !== 'battling'"
                        @pointerdown.prevent="startHold" @pointerup.prevent="stopHold"
                        @pointercancel="stopHold" @pointerleave="stopHold"
                        @mouseleave="stopHold">
                        <span class="reel-icon">🎣</span>
                        <span class="reel-text">{{phase === 'waiting' ? '等待咬钩…' : (holding ? '收线中…' : '按住收线')}}</span>
                    </button>
                    <button class="jerk-btn" :disabled="phase !== 'battling' || !canJerk"
                        :title="canJerk ? '猛拉一提：进度快涨但张力暴涨' : '拉扯为强化鱼竿专属'" @pointerdown.prevent="jerk" @touchstart.prevent="jerk" @mousedown.prevent="jerk">
                        <span class="reel-icon">💪</span>
                        <span class="reel-text">{{canJerk ? '拉扯（猛拉一提）' : '拉扯（需强化鱼竿）'}}</span>
                    </button>
                </div>
                <div class="battle-tip" v-if="phase === 'battling'">{{ battleTipText }}</div>
            <div class="battle-tip" v-else>等待鱼儿咬钩……咬钩后即可收线！</div>
            </div>

            <!-- 装备信息与选择（蓄力时也显示，避免布局跳动导致按钮位移） -->
            <div class="gear-info" v-if="phase === 'idle' || phase === 'result' || phase === 'casting'">
                <div class="gear-row gear-rod-row">
                    <span class="gear-label">🎣 鱼竿（点击选择）：</span>
                    <div class="rod-cards">
                        <div v-for="rod in gear.rods" :key="rod.rodType"
                            class="rod-card" :class="{'rod-selected': selectedRodType === rod.rodType}"
                            @click="selectRod(rod.rodType)">
                            <span class="rod-card-name">{{rod.rodName}}</span>
                            <span v-if="selectedRodType === rod.rodType" class="rod-using">使用中</span>
                            <span class="rod-card-price">{{rod.price}}元</span>
                            <span class="rod-attr">⚡收线×{{rod.reelSpeed}}</span>
                            <span class="rod-attr">🎯稀有+{{rod.rareBonus}}‰</span>
                            <span class="rod-attr">🟩中鱼区+{{rod.zoneBonus}}</span>
                            <span v-if="rod.fishPowerReduce > 0" class="rod-attr">🐟挣扎-{{rod.fishPowerReduce}}</span>
                            <span class="rod-attr">🔩耐久 {{rod.rodDurability}}/30</span>
                        </div>
                        <div v-if="!gear.rods || gear.rods.length === 0" class="gear-chip gear-missing rod-empty">未装备鱼竿（探索工会补给站有售）</div>
                    </div>
                </div>
                <div class="gear-row">
                    <span class="gear-label">🪱 鱼饵：</span>
                    <span class="gear-chip" :class="{'gear-missing': gear.baitCount <= 0}">×{{gear.baitCount}}</span>
                    <span class="bait-bonus" :class="{'bait-bonus-on': useBait && gear.baitCount > 0}">
                        {{useBait && gear.baitCount > 0 ? '使用中：稀有+10‰ · 中鱼区+2' : (gear.baitCount == 0 ? '无鱼饵' : '未使用：无加成')}}
                    </span>
                    <el-switch v-model="useBait"
                        active-text="抛竿消耗1个" inactive-text="不消耗"
                        style="margin-left: 8px;"></el-switch>
                </div>
                <!-- 钓鱼熟练度（2026-09-27 全员开放）：熟练度逐级解锁鱼种，持渔夫称号再享馈赠 -->
                <div class="gear-row" v-if="gear.fisher">
                    <span class="gear-label">🏆 钓鱼熟练度：</span>
                    <span class="gear-chip" :class="{'gear-missing': !gear.fisher.active}">
                        {{gear.fisher.mastery}}/{{gear.fisher.masteryLimit}}
                    </span>
                    <span class="bait-bonus" :class="{'bait-bonus-on': gear.fisher.active}" :title="fisherTip">
                        已解锁 {{gear.fisher.unlockedCount}}/{{gear.fisher.totalCount}} 种鱼<template v-if="gear.fisher.nextName">（下一级：{{gear.fisher.nextName}} {{gear.fisher.nextMastery}}）</template><template v-else>（已全部解锁）</template> · {{gear.fisher.active ? '渔夫馈赠：50% 概率额外+1 尾' : '未持渔夫称号，无馈赠'}}
                    </span>
                    <i v-if="fisherTip" class="el-icon-info" style="margin-left:6px;color:#909399;" :title="fisherTip"></i>
                </div>
            </div>

            <!-- 操作区 -->
            <div class="fish-actions" v-if="phase !== 'battling'">
                <el-button v-if="phase === 'idle' || phase === 'result' || phase === 'casting'" type="primary"
                    class="cast-hold-btn"
                    :disabled="!gear.hasRod || !selectedRodType || (useBait && gear.baitCount <= 0)"
                    @pointerdown.native.prevent="startCast" @pointerup.native.prevent="releaseCast"
                    @pointercancel.native="cancelCast" @pointerleave.native="cancelCast"
                    @mouseleave.native="cancelCast">
                    {{phase === 'casting' ? (castPerfect ? '🌟 完美！松手抛竿' : '蓄力中…松手抛竿！') : (phase === 'result' ? '再抛一竿' : '按住蓄力抛竿')}}
                </el-button>
                <el-button v-if="phase !== 'casting'" @click="showHandbook" :loading="handbookLoading">渔获图鉴</el-button>
                <el-button v-if="phase !== 'casting'" @click="showAchievements" :loading="achievementLoading">钓鱼成就</el-button>
            </div>

            <!-- 渔获图鉴（弹窗，叠加在钓鱼窗口之上） -->
            <el-dialog title="渔获图鉴" custom-class="fish-sub-dialog" width="460px"
                       :visible.sync="handbookVisible" append-to-body>
                <div class="hb-grid" v-if="handbookList != null && handbookList.length > 0">
                    <div v-for="row in handbookList" :key="row.id" class="hb-cell" :class="{'hb-locked': !row.fishCount}">
                        <img :src="ossPath + row.imgsrc" class="hb-img">
                        <span class="hb-name" :style="row.fishCount ? {color: rareColor(row.rarely)} : {}">{{row.name}}</span>
                        <span v-if="row.fishCount" class="hb-count">钓获 ×{{row.fishCount}}</span>
                        <span v-else class="hb-untagged">未捕获</span>
                    </div>
                </div>
                <div v-else class="noHandbook">还没有钓到过鱼，先去抛一竿吧！</div>
            </el-dialog>

            <!-- 钓鱼成就（弹窗，叠加在钓鱼窗口之上） -->
            <el-dialog title="钓鱼成就" custom-class="fish-sub-dialog" width="460px"
                       :visible.sync="achievementVisible" append-to-body>
                <div class="ach-stat" v-if="achievementList.length > 0">
                    已达成 <b class="ach-done">{{achievementStat.achievedCount}}</b> · 可领取 <b class="ach-claim">{{achievementStat.claimableCount}}</b> · 已领取 <b class="ach-got">{{achievementStat.claimedCount}}</b>
                </div>
                <div v-if="achievementList.length > 0" class="ach-list">
                    <div v-for="item in achievementList" :key="item.id" class="ach-item" :class="{'ach-done-item': item.achieved, 'ach-claimed-item': item.claimed}">
                        <div class="ach-row">
                            <span class="ach-name">{{item.achievementName}}</span>
                            <span class="ach-progress" :class="{'ach-progress-done': item.achieved}">{{item.currentValue}} / {{item.targetValue}}</span>
                            <button class="ach-btn" :class="{'ach-btn-claim': item.claimable, 'ach-btn-done': item.claimed}"
                                :disabled="!item.claimable" @click="claimAchievement(item.id)">{{item.claimed ? '已领取' : (item.claimable ? '领取奖励' : '未达成')}}</button>
                        </div>
                        <div class="ach-desc">{{item.achievementDesc}} <span class="ach-reward">奖励：金币+{{item.rewardMoney}}{{item.rewardExp > 0 ? '、经验+'+item.rewardExp : ''}}</span></div>
                    </div>
                </div>
                <div v-else class="noHandbook">成就加载中…</div>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
import {postRequest, getRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'fishingPanel',
  props:{
    fishingVisible: {
      type: Boolean,
      default: false
    },
    fishingSpotId: String,
    fantasyUserBO: Object,
  },
  data() {
    return {
        loading: false,
        isMobile: window.innerWidth <= 768,
        phase: 'idle',        // idle|casting|waiting|battling|result
        waitingHint: false,   // 咬钩前浮漂预动提示
        bite: false,
        biteDelayMs: 1000,
        battle: null,         // {fishPower, zoneStart, zoneEnd, struggleMs}
        progress: 0,
        tension: 0,
        holding: false,
        zoneTimer: 0,
        struggleTimer: 0,
        tickTimer: null,
        zoneMoveRate: 100,   // 当前绿区移动概率（初始100%，触发后回落预设值）
        zoneMoveAccum: 0,    // 概率递增计时（毫秒）
        powerValue: 0,       // 蓄力值 0~100（力量条来回摆动）
        powerDir: 1,         // 蓄力方向 1升 -1降
        powerTimer: null,    // 蓄力动画定时器
        castDistance: 0,     // 本次抛竿距离（米，后端换算）
        castPerfect: false,  // 是否完美蓄力（55%~85%）
        castMsg: '',         // 后端抛竿提示（如空杆原因）
        buffering: true,     // 上钩缓冲期：给玩家反应时间，鱼不挣扎不回落
        battleStart: 0,      // 搏斗开始时间戳
        result: null,         // {success, message}
        blockedHint: '',       // 守卫失败提示（未到结算时长，需再稳住一次重试），非空时覆盖战斗提示区
        showcase: null,       // 渔获水面展示（中鱼庆祝动画）{fishTypeName, fishImgsrc, rareLevel, rareLabel, rareColor, durationMs}（固定居中渲染）
        showcaseTimer: null,  // 展示自动消失定时器
        handbookVisible: false,
        handbookLoading: false,
        achievementVisible: false,
        achievementLoading: false,
        achievementList: [],
        achievementStat: {achievedCount: 0, claimableCount: 0, claimedCount: 0},
        handbookList: [],
        gear: { baitCount: 0, hasRod: false, rods: [] },
        selectedRodType: null,
        useBait: true,
        // 稀有度视觉映射：0普通 1良好 2稀有 3传说
        rareColorMap: { 0: '#909399', 1: '#67c23a', 2: '#e6a23c', 3: '#f56c6c' },
        rareNameMap: { 0: '普通', 1: '良好', 2: '稀有', 3: '传说' },
    };
  },
  computed: {
    zoneStyle() {
      if (!this.battle) return {};
      return { left: this.battle.zoneStart + '%', width: (this.battle.zoneEnd - this.battle.zoneStart) + '%' };
    },
    inZone() {
      return this.battle && this.progress >= this.battle.zoneStart && this.progress <= this.battle.zoneEnd;
    },
    tensionClass() {
      return this.tension > 80 ? 'tension-danger' : (this.tension > 50 ? 'tension-warn' : 'tension-safe');
    },
    // 蓄力值取整显示（力量条按 2.8 步进会带小数）
    powerDisplay() {
      return Math.round(this.powerValue);
    },
    // 拉扯为强化鱼竿专属（rodType 2，普通鱼竿收线慢需要拉扯补进度）
    canJerk() {
      return this.selectedRodType === 2;
    },
    // 渔夫解锁进度 tooltip：新机制摘要 + 全部鱼种解锁门槛（✔已解锁/✘未解锁）
    fisherTip() {
      const fisher = (this.gear && this.gear.fisher) || {};
      const fishes = fisher.fishes || [];
      if (!fishes.length) return '';
      const head = '熟练度逐级解锁鱼种，满熟练才会咬中金龙鱼；每点熟练度 +0.5‰ 稀有率。'
        + (fisher.active ? '\n持渔夫称号：钓获时 50% 概率额外+1 尾（含金龙鱼）。' : '\n未持渔夫称号：无馈赠加成，熟练度照常累积。');
      return head + '\n' + fishes.map(f => (f.unlocked ? '✔ ' : '✘ ') + f.name + '（熟练度 ' + f.mastery + '）').join('\n');
    },
    // 搏斗提示：桌面完整版 / 移动端精简版；守卫提示（鱼还没咬稳）两种端都优先显示
    battleTipText() {
      if (this.blockedHint) return this.blockedHint;
      if (this.isMobile) {
        return this.canJerk
          ? '按住收线把进度拉进绿区稳住即中鱼；松开可放线追绿区，拉扯快但张力暴涨。张力满断线，进度空跑鱼！'
          : '按住收线把进度拉进绿区稳住即中鱼；松开可放线追绿区。张力满断线，进度空跑鱼！（拉扯需强化鱼竿）';
      }
      return this.canJerk
        ? '按住收线：进度右移、张力上涨；松开：张力回落，绿区外进度缓慢左移（可放线追绿区）。拉扯：快速提线但张力暴涨。把进度拉进绿色区稳住即可中鱼，张力100%断线、进度归零跑鱼！'
        : '按住收线：进度右移、张力上涨；松开：张力回落，绿区外进度缓慢左移（可放线追绿区）。把进度拉进绿色区稳住即可中鱼，张力100%断线、进度归零跑鱼！（拉扯为强化鱼竿专属）';
    }
  },
  watch: {
    useBait(val) {
      localStorage.setItem('fantasy_fishing_use_bait', String(val));
    },
    fishingVisible: {
      // immediate：组件由 v-if 创建时 prop 初始即为 true，普通 watch 不触发，导致首次打开不加载装备
      immediate: true,
      handler(newVal) {
        if (newVal === true) {
          this.resetAll();
          this.useBait = localStorage.getItem('fantasy_fishing_use_bait') !== 'false';
          this.loadGear();
        }
      }
    }
  },
  mounted: function () {
    // 横竖屏切换时更新移动端判定（搏斗提示精简版/完整版）
    this._onResize = () => { this.isMobile = window.innerWidth <= 768; };
    window.addEventListener('resize', this._onResize);
  },
  beforeDestroy: function () {
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
      this._onResize = null;
    }
    this.stopTick();
    this.stopCastCharge();
    this.clearShowcase();
  },
  methods: {
    // 装备信息（鱼饵数量/鱼竿列表）
    loadGear: function() {
      getRequest('/item/fishing/gear', {
      }).then(resp=> {
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  const d = respData.data;
                  this.gear = { baitCount: d.baitCount, hasRod: d.hasRod, rods: d.rods || [], fisher: d.fisher };
                  // 记住的鱼竿偏好若已不存在，则默认选强化竿（无则第一把）
                  const saved = Number(localStorage.getItem('fantasy_fishing_rod_type'));
                  const types = (d.rods || []).map((x) => x.rodType);
                  if (types.indexOf(saved) >= 0) {
                    this.selectedRodType = saved;
                  } else if (types.indexOf(2) >= 0) {
                    this.selectedRodType = 2;
                  } else if (types.length > 0) {
                    this.selectedRodType = types[0];
                  } else {
                    this.selectedRodType = null;
                  }
              }
          }
      }, resp=> { /* 装备信息获取失败不打断钓鱼流程 */ });
    },
    // 选择鱼竿
    selectRod: function(rodType) {
      this.selectedRodType = rodType;
      localStorage.setItem('fantasy_fishing_rod_type', String(rodType));
    },
    resetAll() {
      this.stopTick();
      this.stopCastCharge();
      this.phase = 'idle';
      this.bite = false;
      this.battle = null;
      this.progress = 0;
      this.tension = 0;
      this.holding = false;
      this.zoneTimer = 0;
      this.struggleTimer = 0;
      this.result = null;
      this.clearShowcase();
      this.handbookVisible = false;
      this.achievementVisible = false;
      this.castDistance = 0;
      this.castPerfect = false;
      this.castMsg = '';
    },
    fishing_dialog_close() {
      if (this.phase === 'battling') {
        // 搏斗中允许直接关闭（后端战斗上下文会过期自动失效）
        this.stopTick();
        this.phase = 'idle';
      }
      this.clearShowcase();
      this.$emit("fishing_dialog_close");
    },
    // 清除水面展示（连同定时器）
    clearShowcase() {
      if (this.showcaseTimer) {
        clearTimeout(this.showcaseTimer);
        this.showcaseTimer = null;
      }
      this.showcase = null;
    },
    // 蓄力：按住抛竿按钮开始（力量条来回摆动）
    startCast: function(e) {
      if (this.phase !== 'idle' && this.phase !== 'result') return;
      if (!this.fishingSpotId) {
        Message.error('钓鱼点信息缺失');
        return;
      }
      // 前端硬守卫：disabled 视觉态可能被指针事件路径绕过
      if (!this.gear.hasRod || !this.selectedRodType || (this.useBait && this.gear.baitCount <= 0)) {
        Message.warning(!this.gear.hasRod ? '需要鱼竿才能钓鱼'
          : (this.useBait && this.gear.baitCount <= 0) ? '没有鱼饵，请先把开关切到「不消耗」'
          : '请先选择鱼竿');
        return;
      }
      // 指针捕获：蓄力期间无论布局变化/手指抖动，松开事件都送达本按钮（不会丢 releaseCast）
      if (e && e.pointerId != null && e.target && e.target.setPointerCapture) {
        try { e.target.setPointerCapture(e.pointerId); } catch (err) {}
      }
      this.phase = 'casting';
      this.result = null;
      this.powerValue = 0;
      this.powerDir = 1;
      this.castDistance = 0;
      this.castPerfect = false;
      this.castMsg = '';
      this.stopCastCharge();
      this.powerTimer = setInterval(() => {
        this.powerValue += 2.8 * this.powerDir;
        if (this.powerValue >= 100) {
          this.powerValue = 100;
          this.powerDir = -1;
        } else if (this.powerValue <= 0) {
          this.powerValue = 0;
          this.powerDir = 1;
        }
      }, 30);
    },
    // 蓄力中离开按钮：取消抛竿
    cancelCast: function() {
      if (this.phase !== 'casting') return;
      this.stopCastCharge();
      this.phase = 'idle';
    },
    stopCastCharge: function() {
      if (this.powerTimer) {
        clearInterval(this.powerTimer);
        this.powerTimer = null;
      }
    },
    // 松手抛出：按当前蓄力值抛竿
    releaseCast: function() {
      if (this.phase !== 'casting') return;
      this.stopCastCharge();
      this.castPerfect = this.powerValue >= 55 && this.powerValue <= 85;
      this.doCast(Math.round(this.powerValue));
    },
    // 抛竿
    doCast: function(power) {
      if (!this.fishingSpotId) {
        Message.error('钓鱼点信息缺失');
        return;
      }
      if (!this.gear.hasRod || !this.selectedRodType || (this.useBait && this.gear.baitCount <= 0)) {
        Message.warning(!this.gear.hasRod ? '需要鱼竿才能钓鱼'
          : (this.useBait && this.gear.baitCount <= 0) ? '没有鱼饵，请先把开关切到「不消耗」'
          : '请先选择鱼竿');
        return;
      }
      this.phase = 'casting';
      this.result = null;
      postRequest('/item/fishing/cast', {
        spotId: this.fishingSpotId,
        rodType: this.selectedRodType || 1,
        useBait: this.useBait,
        power: (null == power || power < 0) ? 70 : power
      }).then(resp=> {
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  const d = respData.data;
                  this.loadGear();
                  this.castMsg = respData.message || '';
                  this.castDistance = d.distance || 0;
                  this.phase = 'waiting';
                  this.bite = d.bite;
                  this.biteDelayMs = d.biteDelayMs || 1200;
                  if (d.bite) {
                    this.battle = {
                      fishPower: d.fishPower,
                      zoneStart: d.zoneStart,
                      zoneEnd: d.zoneEnd,
                      struggleMs: d.struggleMs,
                      zoneMoveChance: d.zoneMoveChance || 0,
                      rareLevel: d.rareLevel || 0,
                      reelSpeed: d.reelSpeed || 1.0,
                    };
                  }
                  // 等待咬钩（结束前1秒浮漂预动提示）
                  const total = this.biteDelayMs;
                  setTimeout(() => {
                    if (this.phase !== 'waiting') return;
                    this.waitingHint = true;
                    setTimeout(() => {
                      if (this.phase !== 'waiting') return;
                      this.waitingHint = false;
                      if (this.bite) {
                        this.startBattle();
                      } else {
                        this.result = {success: false, message: this.castMsg || '水面恢复了平静，没有鱼咬钩。'};
                        this.phase = 'result';
                      }
                    }, Math.max(500, total - (this.biteDelayMs - 800)));
                  }, this.biteDelayMs - 800);
              } else {
                  this.phase = 'idle';
                  Message.error(respData.message);
              }
          } else {
              this.phase = 'idle';
              Message.error('用户非法⊙﹏⊙∥!');
          }
      }, resp=> {
          this.phase = 'idle';
          Message.error('用户非法⊙﹏⊙∥!');
      });
    },
    // 开始搏斗
    startBattle: function() {
      this.phase = 'battling';
      this.progress = 5;
      this.tension = 0;
      this.holding = false;
      this.blockedHint = '';   // 新一局清除守卫提示
      this.zoneTimer = 0;
      this.struggleTimer = 0;
      // 绿区移动概率状态机：进绿区首次挣扎必然移动，之后回落预设值并每秒递增
      this.zoneMoveRate = 100;
      this.zoneMoveAccum = 0;
      // 上钩缓冲期：界面刚切换，给玩家1.2秒反应时间
      this.buffering = true;
      this.battleStart = Date.now();
      this.stopTick();
      this.tickTimer = setInterval(this.tick, 80);
    },
    // 每帧逻辑
    tick: function() {
      if (this.phase !== 'battling') return;
      // 上钩缓冲期：鱼静止，等待玩家就位（按住收线则提前结束缓冲）
      if (this.buffering) {
        if (this.holding || Date.now() - this.battleStart >= 1200) {
          this.buffering = false;
        } else {
          return;
        }
      }
      // 收线：进度上升、张力上升；高张力收线变慢；强化鱼竿收线更快（reelSpeed）
      if (this.holding) {
        // 张力逼近临界自动松线保护（防止松手事件丢失导致的必断线）
        if (this.tension >= 92) {
          this.holding = false;
        } else {
          this.progress += (this.tension < 60 ? 1.3 : 0.8) * (this.battle.reelSpeed || 1.0);
          this.tension += 3;
        }
      } else {
        this.tension = Math.max(0, this.tension - 5);
        // 放线：绿区外松开时进度左移（可主动放线追踪漂移的绿区；绿区内鱼已力竭被线牵住，进度稳定）
        if (!this.inZone) {
          this.progress -= 1.0;
        }
      }
      // 绿区移动概率随时间递增（每秒+20，封顶100）：拖得越久鱼越躁
      this.zoneMoveAccum += 80;
      if (this.zoneMoveAccum >= 1000) {
        this.zoneMoveAccum -= 1000;
        this.zoneMoveRate = Math.min(100, this.zoneMoveRate + 20);
      }
      // 鱼挣扎
      this.struggleTimer += 80;
      if (this.struggleTimer >= this.battle.struggleMs) {
        this.struggleTimer = 0;
        const power = this.inZone ? this.battle.fishPower * 0.5 : this.battle.fishPower;
        this.progress -= power;
        this.tension += power * 2;
        // 挣扎时按当前概率拽动绿色中鱼区；触发后概率回落预设值（蓄力循环）
        if (this.inZone && this.battle.zoneMoveChance > 0 && Math.random() * 100 < this.zoneMoveRate) {
          this.moveZone();
          this.zoneMoveRate = this.battle.zoneMoveChance;
          this.zoneMoveAccum = 0;
        }
      }
      // 中鱼区：鱼力竭，进度缓慢自动上升
      if (this.inZone) {
        // 区内自动上升在绿区右缘封顶：避免数值溢出 zoneEnd 导致刻度在绿条右端反复横跳、zoneTimer 永远凑不满
        this.progress = Math.min(this.progress + 0.35, this.battle.zoneEnd);
        this.zoneTimer += 80;
      } else {
        // 短暂离开绿区不清零，仅衰减 250ms：挣扎/漂移造成的边界抖动不会前功尽弃
        this.zoneTimer = Math.max(0, this.zoneTimer - 250);
      }
      this.progress = Math.min(100, this.progress);
      // 结算判定
      if (this.tension >= 100) {
        this.finish(false);
        return;
      }
      if (this.progress <= 0) {
        this.finish(false);
        return;
      }
      if (this.zoneTimer >= 1200) {
        this.finish(true);
        return;
      }
    },
    // 绿区漂移：鱼挣扎时随机移动中鱼区位置
    moveZone: function() {
      const width = this.battle.zoneEnd - this.battle.zoneStart;
      const min = 5;
      const max = 95 - width;
      const delta = 6 + Math.floor(Math.random() * 7); // 6~12，可被放线追上
      const dir = Math.random() < 0.5 ? -1 : 1;
      let newStart = this.battle.zoneStart + dir * delta;
      // 贴边时强制反向漂移，避免绿区卡在边界反复不动
      if (newStart < min) newStart = this.battle.zoneStart + delta;
      if (newStart > max) newStart = this.battle.zoneStart - delta;
      this.battle.zoneStart = newStart;
      this.battle.zoneEnd = newStart + width;
    },
    // 稀有度颜色
    rareColor(level) {
      return this.rareColorMap[level] || '#909399';
    },
    // 拉扯：猛拉一提（强化鱼竿专属）
    jerk: function() {
      if (this.phase !== 'battling' || !this.canJerk) return;
      this.progress += 12;
      this.tension += 18;
      if (this.tension >= 100) {
        this.finish(false);
        return;
      }
      this.progress = Math.min(100, this.progress);
    },
    // 按住收线：指针捕获保证松手/滑出按钮也一定触发 stopHold（不会卡在收线状态）
    startHold: function(e) {
      if (this.phase !== 'battling') return;
      if (e && e.pointerId != null && e.target && e.target.setPointerCapture) {
        try { e.target.setPointerCapture(e.pointerId); } catch (err) {}
      }
      this.holding = true;
    },
    stopHold: function() {
      this.holding = false;
    },
    stopTick: function() {
      if (this.tickTimer) {
        clearInterval(this.tickTimer);
        this.tickTimer = null;
      }
    },
    // 结算：提交后端
    finish: function(success) {
      this.stopTick();
      this.holding = false;
      postRequest('/item/fishing/catch', {
        success: success
      }).then(resp=> {
          // 守卫失败（未到最短结算时长，如"鱼还没咬稳"）：后端保留战斗上下文可稍后重试，
          // 此处不关闭搏斗、不丢鱼，只重置中鱼计时让玩家再稳住一次即可再次结算。
          const blockMsg = (resp && resp.data && resp.data.message) ? String(resp.data.message) : '';
          if (blockMsg.indexOf('鱼还没咬稳') >= 0) {
              this.holding = false;
              this.zoneTimer = 0;      // 需重新在绿区稳住 1.2s 才算中鱼，避免立刻重复 POST 的守卫死循环
              this.struggleTimer = 0;
              this.blockedHint = '鱼还没咬稳，别急——把它再稳进绿区等一小会儿，就能收线啦。';
              this.stopTick();
              this.tickTimer = setInterval(this.tick, 80);  // 恢复搏斗循环
              return;
          }
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  const d = respData.data || {};
                  this.result = {
                    success: success,
                    message: respData.message,
                    fishTypeName: d.fishTypeName || null,
                    rareLevel: d.rareLevel
                  };
                  // 渔获水面展示：中鱼且后端返回展示数据时，在浮漂处播放心跳庆祝动画
                  this.clearShowcase();
                  if (success && d.showcaseId) {
                    this.showcase = {
                      showcaseId: d.showcaseId,
                      fishTypeName: d.fishTypeName,
                      fishImgsrc: d.fishImgsrc,
                      rareLevel: d.rareLevel || 0,
                      rareLabel: d.rareLabel || this.rareNameMap[d.rareLevel] || '',
                      rareColor: d.rareColor || this.rareColorMap[d.rareLevel] || '#fff',
                      durationMs: d.showcaseDurationMs || 3500
                    };
                    this.showcaseTimer = setTimeout(() => {
                      this.showcase = null;
                    }, this.showcase.durationMs);
                  }
              } else {
                  this.result = {success: false, message: respData.message};
              }
          } else {
              this.result = {success: false, message: '结算异常，请重新抛竿'};
          }
          this.phase = 'result';
          // 结算完成后刷新装备与渔夫加成（中鱼熟练度+1、稀有渔获+2，鱼竿耐久也会变化）
          this.loadGear();
          // 钓鱼消耗体力疲劳，刷新玩家属性
          this.$store.dispatch('user/fetchUserDetail');
      }, resp=> {
          this.result = {success: false, message: '结算异常，请重新抛竿'};
          this.phase = 'result';
          this.loadGear();
      });
    },
    // 渔获图鉴（弹窗）
    showHandbook: function() {
      if (this.handbookVisible) {
        this.handbookVisible = false;
        return;
      }
      this.achievementVisible = false;
      this.handbookLoading = true;
      getRequest('/item/fishing/handbook', {
      }).then(resp=> {
          this.handbookLoading = false;
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  this.handbookList = respData.data || [];
                  this.handbookVisible = true;
              } else {
                  Message.error(respData.message);
              }
          } else {
              Message.error('图鉴查询失败');
          }
      }, resp=> {
          this.handbookLoading = false;
          Message.error('图鉴查询异常');
      });
    },
    // 钓鱼成就（弹窗）
    showAchievements: function() {
      if (this.achievementVisible) {
        this.achievementVisible = false;
        return;
      }
      this.handbookVisible = false;
      this.achievementLoading = true;
      getRequest('/item/fishing/achievement/list', {
      }).then(resp=> {
          this.achievementLoading = false;
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  const d = respData.data || {};
                  this.achievementList = d.list || [];
                  this.achievementStat = {
                    achievedCount: d.achievedCount || 0,
                    claimableCount: d.claimableCount || 0,
                    claimedCount: d.claimedCount || 0
                  };
                  this.achievementVisible = true;
              } else {
                  Message.error(respData.message);
              }
          } else {
              Message.error('成就查询失败');
          }
      }, resp=> {
          this.achievementLoading = false;
          Message.error('成就查询异常');
      });
    },
    // 领取成就奖励
    claimAchievement: function(achievementId) {
      postRequest('/item/fishing/achievement/claim', {achievementId: achievementId}).then(resp => {
        if (resp.status == 200 && 200 == resp.data.status) {
          Message.success(resp.data.message || '领取成功');
          this.showAchievementsRefresh();
        } else {
          Message.error(resp.data.message || '领取失败');
        }
      }, () => {
        Message.error('领取异常');
      });
    },
    // 刷新成就列表（领取后）
    showAchievementsRefresh: function() {
      getRequest('/item/fishing/achievement/list', {}).then(resp => {
        if (resp.status == 200 && 200 == resp.data.status) {
          const d = resp.data.data || {};
          this.achievementList = d.list || [];
          this.achievementStat = {
            achievedCount: d.achievedCount || 0,
            claimableCount: d.claimableCount || 0,
            claimedCount: d.claimedCount || 0
          };
        }
      }, () => {});
    },
  }
}
</script>

<style scoped>
.fish-scene {
  position: relative;
  height: 220px;
  overflow: hidden;
  border-radius: 6px;
  background: linear-gradient(180deg, #bfe3ff 0%, #e8f6ff 55%, #6db3e8 56%, #3f8fd2 100%);
}
/* 水面波纹 */
.water {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60px;
  background: linear-gradient(180deg, rgba(109,179,232,0.9), rgba(63,143,210,0.95));
  overflow: hidden;
}
.wave {
  position: absolute;
  top: -6px;
  height: 14px;
  border-radius: 50%;
  border-top: 3px solid rgba(255,255,255,0.8);
}
.wave1 { left: -30px; width: 180px; animation: fishwave 2.2s linear infinite; }
.wave2 { left: 90px; width: 220px; animation: fishwave 3.1s linear infinite reverse; }
.wave3 { left: 260px; width: 200px; animation: fishwave 2.7s linear infinite; }
@keyframes fishwave {
  0% { transform: translateX(0); }
  100% { transform: translateX(140px); }
}
/* 浮漂 */
.bobber {
  position: absolute;
  top: 130px;
  left: 50%;
  transform: translateX(-50%);
  transition: transform 0.15s;
}
.bobber.nibble { animation: nibble 0.35s ease-in-out infinite; }
@keyframes nibble {
  0% { transform: translateX(-50%) translateY(0); }
  50% { transform: translateX(-50%) translateY(-6px); }
  100% { transform: translateX(-50%) translateY(0); }
}
.bobber-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ff5722;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.4);
}
/* 鱼 */
.fish-icon {
  position: absolute;
  top: 140px;
  left: 50%;
  font-size: 56px;
  transform: translateX(-50%);
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.35));
}
.fish-icon.struggling { animation: fishstruggle 0.4s ease-in-out infinite; }
@keyframes fishstruggle {
  0% { transform: translateX(-50%) rotate(0deg) translateY(0); }
  25% { transform: translateX(-50%) rotate(-14deg) translateY(-8px); }
  75% { transform: translateX(-50%) rotate(14deg) translateY(-4px); }
  100% { transform: translateX(-50%) rotate(0deg) translateY(0); }
}
/* 渔获水面展示（中鱼庆祝动画）：贴场景底部对齐，名字在鱼下方；
   高度随鱼图自动向上生长，保证名字落在底部状态栏之上、不被场景 overflow 裁切 */
.showcase-float {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  z-index: 12;
  animation: showcaseLand 0.5s ease-out;
}
@keyframes showcaseLand {
  0% { opacity: 0; transform: translateX(-50%) translateY(14px) scale(0.7); }
  35% { opacity: 1; transform: translateX(-50%) translateY(-46px) scale(1.08) rotate(-6deg); }
  60% { transform: translateX(-50%) translateY(4px) scale(0.98); }
  100% { transform: translateX(-50%) translateY(0) scale(1); }
}
.showcase-splash {
  position: absolute;
  bottom: 34px;
  left: 50%;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 3px solid rgba(255,255,255,0.9);
  transform: translateX(-50%);
  animation: splashRing 0.9s ease-out infinite;
  z-index: -1;
}
@keyframes splashRing {
  0% { opacity: 0.9; transform: translateX(-50%) scale(0.4); }
  100% { opacity: 0; transform: translateX(-50%) scale(1.35); }
}
.showcase-splash.splash-rare { border-color: rgba(255, 215, 110, 0.95); }
/* 鱼图源图是 128x160 竖版、鱼身只占中间约 1/3 高度，直接放大盒子会留一大圈透明边；
   改用扁盒子 + cover 裁掉上下留白，鱼身实际显示尺寸约翻倍（最高的黑鱼内容占 54%，窗口留 60% 不切鳍） */
.showcase-fish {
  width: 150px;
  height: 112px;
  object-fit: cover;
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.4));
  animation: showcaseBob 1.6s ease-in-out infinite;
}
.showcase-emoji {
  font-size: 96px;
  line-height: 1;
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.4));
  animation: showcaseBob 1.6s ease-in-out infinite;
}
.showcase-fish-rare {
  animation: showcaseBob 1.3s ease-in-out infinite, rareGlow 1.8s ease-in-out infinite;
}
@keyframes showcaseBob {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-6px) rotate(3deg); }
}
@keyframes rareGlow {
  0%, 100% { filter: drop-shadow(0 0 2px rgba(255,200,80,0.5)); }
  50% { filter: drop-shadow(0 0 10px rgba(255,200,80,0.95)); }
}
.showcase-name {
  margin-top: 2px;
  font-size: 15px;
  font-weight: bold;
  white-space: nowrap;
  text-shadow: 0 1px 3px rgba(0,0,0,0.7);
  animation: showcaseFade 2s ease-in-out infinite alternate;
}
@keyframes showcaseFade {
  0% { opacity: 0.85; }
  100% { opacity: 1; }
}
.showcase-tag {
  display: inline-block;
  margin-left: 4px;
  padding: 0 5px;
  border-radius: 8px;
  font-size: 11px;
  line-height: 15px;
  background: rgba(255,255,255,0.9);
  border: 1px solid;
  vertical-align: 1px;
}
.scene-text {
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 14px;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0,0,0,0.5);
  padding: 0 10px;
}
.battle-text.danger { color: #ffd54f; font-weight: bold; }
.hook-hint {
  color: #ffd54f;
  font-weight: bold;
  font-size: 16px;
  animation: hookHint 0.6s ease-in-out infinite;
}
@keyframes hookHint {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.08); }
}
.success-text { color: #a5ffa5; }
.fail-text { color: #ffb3b3; }
/* 搏斗UI */
.battle-ui { margin-top: 12px; }
.fishbar-wrap { margin-bottom: 8px; }
.fishbar-label, .tension-label {
  font-size: 13px;
  color: #555;
  margin-bottom: 2px;
}
.fishbar {
  position: relative;
  height: 26px;
  border-radius: 13px;
  overflow: hidden;
  border: 1px solid #999;
}
.fishbar-red-left, .fishbar-red-right {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;
  background: repeating-linear-gradient(45deg, #ffb3b3, #ffb3b3 6px, #ff9e9e 6px, #ff9e9e 12px);
}
.fishbar-red-right { right: 0; }
.fishbar-zone {
  position: absolute;
  top: 0;
  bottom: 0;
  background: repeating-linear-gradient(45deg, #81e08b, #81e08b 6px, #5fd46b 6px, #5fd46b 12px);
  z-index: 1;
  transition: left 0.35s ease;
}
/* 鱼躁动预警：绿区闪烁提示即将漂移 */
.fishbar-zone.zone-alert {
  animation: zonePulse 0.5s ease-in-out infinite;
}
@keyframes zonePulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
}
.rare-tag {
  display: inline-block;
  margin-left: 6px;
  padding: 0 6px;
  border-radius: 8px;
  font-size: 11px;
  line-height: 16px;
  background: #fff3e0;
  color: #e6a23c;
  border: 1px solid #e6a23c;
}
.fishbar-marker {
  position: absolute;
  top: -3px;
  bottom: -3px;
  width: 5px;
  margin-left: -2px;
  background: #222;
  border-radius: 3px;
  z-index: 2;
  transition: left 0.08s linear;
}
.tension-wrap { display: flex; align-items: center; margin-bottom: 10px; }
.tension-label { margin: 0 8px 0 0; }
.tensionbar {
  flex: 1;
  height: 14px;
  border-radius: 7px;
  background: #eee;
  border: 1px solid #ccc;
  overflow: hidden;
}
.tensionbar-fill { height: 100%; border-radius: 7px; transition: width 0.08s linear, background 0.2s; }
.tension-safe { background: #67c23a; }
.tension-warn { background: #e6a23c; }
.tension-danger { background: #f56c6c; }
.tension-num { width: 52px; text-align: center; font-size: 13px; font-weight: bold; margin-left: 6px; }
.battle-actions { display: flex; gap: 10px; justify-content: center; margin-bottom: 8px; }
.reel-btn, .jerk-btn {
  border: none;
  border-radius: 8px;
  padding: 10px 22px;
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}
.reel-btn { background: #3f8fd2; }
.reel-btn.reeling { background: #2c6ba0; transform: scale(0.96); }
/* 上钩缓冲期：按钮脉冲引导 */
.reel-btn.reel-hint {
  animation: reelPulse 0.7s ease-in-out infinite;
}
@keyframes reelPulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(63, 143, 210, 0.7); }
  50% { box-shadow: 0 0 0 10px rgba(63, 143, 210, 0); }
}
.jerk-btn { background: #e6a23c; }
.jerk-btn:active { background: #c98a2a; }
.reel-icon { display: block; font-size: 20px; }
.reel-text { font-size: 12px; }
.battle-tip { font-size: 12px; color: #909399; line-height: 1.6; }
/* 等待咬钩：搏斗区置灰 */
.battle-ui-waiting {
  opacity: 0.65;
}
.reel-btn:disabled, .jerk-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  filter: grayscale(0.4);
}
.gear-info { margin-top: 10px; text-align: left; padding: 0 6px; }
.gear-row { margin-bottom: 6px; display: flex; align-items: center; flex-wrap: wrap; }
.gear-label { font-size: 13px; color: #555; margin-right: 4px; }
.gear-chip {
  display: inline-block;
  margin: 0 4px;
  padding: 4px 12px;
  border-radius: 12px;
  background: #eef7ee;
  border: 1px solid #b8dcb8;
  color: #406e40;
  font-size: 13px;
}
.gear-chip.gear-missing {
  background: #fdf0f0;
  border-color: #e3b3b3;
  color: #c05656;
}
.gear-rod-row {
  display: block;
}
/* 鱼竿选择：每根鱼竿一条横行（名称/使用中/价格/属性/耐久 单行排开） */
.rod-cards {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
}
.rod-card {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 6px 10px;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  transition: all 0.15s;
  background: #fafafa;
}
.rod-card:hover {
  border-color: #3f8fd2;
  background: #f4faff;
}
.rod-card.rod-selected {
  background: #dceeff;
  border-color: #3f8fd2;
  box-shadow: 0 0 0 1px #3f8fd2;
}
.rod-card-name {
  font-weight: bold;
  font-size: 13px;
  color: #333;
}
.rod-using {
  font-size: 11px;
  color: #2c6ba0;
  background: #fff;
  border: 1px solid #3f8fd2;
  border-radius: 8px;
  padding: 0 6px;
  line-height: 16px;
}
.rod-card-price {
  font-size: 12px;
  color: #e6a23c;
  font-weight: bold;
}
.rod-attr {
  font-size: 12px;
  color: #606266;
  background: #fff;
  border-radius: 8px;
  padding: 1px 6px;
  line-height: 16px;
}
.rod-card.rod-selected .rod-attr {
  background: #f0f7ff;
}
.rod-empty {
  display: inline-block;
}
.bait-bonus {
  font-size: 12px;
  color: #909399;
  margin-left: 6px;
}
.bait-bonus.bait-bonus-on {
  color: #67c23a;
  font-weight: bold;
}
.fish-actions { margin-top: 12px; text-align: center; }
/* 蓄力力量条（场景内浮层，不参与文档流布局） */
.power-wrap {
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
  width: 72%;
  z-index: 3;
  background: rgba(255, 255, 255, 0.88);
  border-radius: 10px;
  padding: 8px 12px 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.18);
}
.power-head {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 4px;
}
.power-label {
  font-size: 13px;
  font-weight: bold;
  color: #3f8fd2;
}
.power-tip {
  font-size: 12px;
  color: #909399;
}
.powerbar {
  position: relative;
  height: 20px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #bbb;
  background: repeating-linear-gradient(90deg, #ffb3b3, #ffb3b3 8px, #ff9e9e 8px, #ff9e9e 16px);
}
.powerbar-best {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 55%;
  width: 30%;
  background: repeating-linear-gradient(90deg, #81e08b, #81e08b 8px, #5fd46b 8px, #5fd46b 16px);
}
.powerbar-fill {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background: rgba(63, 143, 210, 0.35);
  transition: width 0.03s linear;
}
.powerbar-fill.powerbar-perfect {
  background: rgba(95, 212, 107, 0.45);
}
.powerbar-marker {
  position: absolute;
  top: -2px;
  bottom: -2px;
  width: 4px;
  margin-left: -2px;
  background: #222;
  border-radius: 2px;
  z-index: 2;
}
/* 抛竿蓄力按钮：禁止触摸手势抢占（滚动/长按菜单），保证按住期间 pointer 事件只归按钮 */
.cast-hold-btn {
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
}
.perfect-text {
  color: #ffe066 !important;
  font-weight: bold;
}
.noHandbook { padding: 14px; text-align: center; color: #909399; font-size: 13px; }
/* 图鉴：卡片网格，每格 鱼图+名字+钓获次数（未捕获灰化） */
.hb-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  gap: 8px;
}
.hb-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 10px 6px 8px;
  background: #fafafa;
}
.hb-img {
  width: 52px;
  height: 52px;
  object-fit: contain;
}
.hb-name {
  font-size: 13px;
  font-weight: bold;
}
.hb-count {
  font-size: 11px;
  color: #909399;
}
.hb-untagged {
  font-size: 11px;
  color: #bbb;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0 6px;
  line-height: 16px;
}
.hb-cell.hb-locked {
  background: #f5f5f5;
}
.hb-locked .hb-img {
  filter: grayscale(1);
  opacity: 0.4;
}
.hb-locked .hb-name {
  color: #bbb !important;
}

/* 移动端适配：整窗紧凑化放进一屏，不出滚动条 */
@media (max-width: 768px) {
  .fish-scene { height: 136px; }
  .water { height: 48px; }
  .fish-icon { font-size: 40px; top: 84px; }
  .bobber { top: 72px; }
  /* 场景变矮后渔获展示同步缩小并上移，避免名字整条跑到场景外看不到 */
  .showcase-float { bottom: 30px; }
  .showcase-fish { width: 96px; height: 72px; }
  .showcase-emoji { font-size: 52px; }
  .showcase-name { font-size: 12px; }
  /* 搏斗区压缩 */
  .battle-ui { margin-top: 8px; }
  .fishbar { height: 22px; border-radius: 11px; }
  .fishbar-label, .tension-label { font-size: 12px; margin-bottom: 1px; }
  .tensionbar { height: 12px; }
  .tension-num { width: 44px; font-size: 12px; }
  .battle-actions { gap: 8px; margin-bottom: 6px; }
  .reel-btn, .jerk-btn { padding: 8px 10px; flex: 1; }
  .reel-icon { font-size: 18px; }
  .battle-tip { font-size: 11px; line-height: 1.5; }
  /* 装备区压缩：鱼竿单行横条 */
  .gear-info { margin-top: 6px; padding: 0 2px; }
  .gear-row { margin-bottom: 4px; }
  .gear-label { font-size: 12px; }
  .gear-chip { padding: 2px 8px; font-size: 12px; margin: 0 2px; }
  .bait-bonus { margin-left: 2px; font-size: 11px; }
  .rod-cards { gap: 4px; margin-top: 2px; }
  .rod-card { padding: 4px 8px; gap: 2px 6px; }
  .rod-card-name { font-size: 12px; }
  .rod-using { font-size: 10px; line-height: 14px; padding: 0 4px; }
  .rod-card-price { font-size: 11px; }
  .rod-attr { font-size: 10px; padding: 0 4px; line-height: 14px; }
  /* 操作区压缩 */
  .fish-actions { margin-top: 8px; }
  .fish-actions .el-button { padding: 8px 10px; font-size: 13px; }
  .el-switch__label { font-size: 11px; }
  /* 图鉴弹窗：网格与格子紧凑化，8 种鱼小屏不出内滚 */
  .hb-grid { gap: 6px; }
  .hb-cell { padding: 6px 4px 5px; }
  .hb-img { width: 44px; height: 44px; }
  .hb-name { font-size: 12px; }
}
/* 钓鱼成就 */
.ach-stat { font-size: 13px; color: #606266; text-align: center; margin-bottom: 8px; }
.ach-done { color: #67c23a; } .ach-claim { color: #e6a23c; } .ach-got { color: #909399; }
.ach-list { max-height: 320px; overflow-y: auto; }
.ach-item { border: 1px solid #ebeef5; border-radius: 6px; padding: 8px 10px; margin-bottom: 8px; background: #fafafa; }
.ach-item.ach-done-item { border-color: #67c23a; background: #f7fbf2; }
.ach-item.ach-claimed-item { opacity: 0.6; }
.ach-row { display: flex; align-items: center; gap: 8px; }
.ach-name { font-size: 14px; font-weight: bold; color: #303133; flex: 1; }
.ach-progress { font-size: 12px; color: #c0c4cc; }
.ach-progress-done { color: #67c23a; }
.ach-btn { font-size: 12px; padding: 2px 10px; border-radius: 11px; border: none; cursor: pointer; background: #dcdfe6; color: #606266; }
.ach-btn.ach-btn-claim { background: #e6a23c; color: #fff; }
.ach-btn.ach-btn-done { background: #67c23a; color: #fff; }
.ach-btn:disabled { cursor: default; }
.ach-desc { font-size: 12px; color: #909399; margin-top: 4px; }
.ach-reward { color: #e6a23c; }
</style>